(() => {
  const MOBILE = '(max-width: 749px)';

  const init = () => {
    if (!window.matchMedia(MOBILE).matches) return;

    const accordions = [...document.querySelectorAll('.product-page-info accordion-content')];
    accordions.forEach((accordion) => {
      const button = accordion.querySelector('.accordion-button');
      const content = accordion.querySelector(':scope > .accordion-content');
      if (!button || !content) return;

      button.setAttribute('aria-expanded', content.style.maxHeight ? 'true' : 'false');

      if (button.dataset.shPlayMobileBound === 'true') return;
      button.dataset.shPlayMobileBound = 'true';

      button.addEventListener('click', () => {
        window.setTimeout(() => {
          const isOpen = Boolean(content.style.maxHeight);
          button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

          if (!isOpen) return;
          accordions.forEach((other) => {
            if (other === accordion) return;
            const otherButton = other.querySelector('.accordion-button');
            const otherContent = other.querySelector(':scope > .accordion-content');
            if (!otherButton || !otherContent || !otherContent.style.maxHeight) return;
            otherContent.style.maxHeight = null;
            otherButton.classList.remove('accordion__active');
            otherButton.setAttribute('aria-expanded', 'false');
          });
        }, 0);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
